import React, { useState, Fragment } from 'react'

import { connect } from 'react-redux'
import { Col, Well, Button, Collapse, FormGroup, InputGroup, FormControl, Glyphicon } from 'react-bootstrap'
// import { Link } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'

import { handleChangeSAPFilter } from '../reducers/manageSAPResources'
import NewSAPResourceModal from './NewSAPResourceModal'

const SAPResourcesSidebar = (props) => {
	const [ open, setOpen ] = useState(false)
	const [ showNewSAPResourceModal, setShowNewSAPResourceModal ] = useState(false)

	const {
		getResourcesWithFilters,
		handleChangeSAPFilter,
		sortBy,
		searchTerm,
	} = props

	const handleEnterPress = (e) => {
		if (e.key === 'Enter') {
			return getResourcesWithFilters(1)
		}
		return null
	}

	const toggleShowNewSAPResourceModal = () => {
		setShowNewSAPResourceModal(!showNewSAPResourceModal)
	}

	const metaDataFilters = [
		{ displayName: 'Author(s)', dataName: 'genesisUsers', filterName: 'authorFilters' },
		{ displayName: 'External Client', dataName: 'clients', filterName: 'externalClientFilters' },
		{ displayName: 'Therapeutic Areas', dataName: 'therapeuticAreas', filterName: 'therapeuticAreaFilters' },
		{ displayName: 'Designs', dataName: 'designs', filterName: 'designFilters' },
		{ displayName: 'Data Sources', dataName: 'dataSources', filterName: 'dataSourceFilters' },
		{ displayName: 'Methods', dataName: 'methods', filterName: 'methodFilters' },
		{ displayName: 'Content', dataName: 'contents', filterName: 'contentFilters' },
	]

	const getLabelKeyFunc = (type) => {
		if (type.toLowerCase() === 'clients') {
			return option => `${option.name} ${option.short_code}`
		} else if (type.toLowerCase() === 'genesisusers') {
			return option => `${option.first_name} ${option.last_name}`
		}

		return option => option.name
	}

	const filters = (
		<Well>
			<div>
				<center>
					{/* <Link to="/sap-repository/new/"> */}
						<Button onClick={toggleShowNewSAPResourceModal}>New Resource</Button>
					{/* </Link> */}
				</center>

				<br />

				<center>
					<h4>Sort By</h4>
				</center>
				<br />
				<FormControl
					componentClass="select"
					placeholder="Sort Projects"
					value={sortBy}
					onChange={e => handleChangeSAPFilter('sortBy', e.target.value)}
				>
					<option value="">-</option>
					<option value="-created_date">Most Recent</option>
					<option value="created_date">Oldest</option>
					<option value="title">Title (Ascending)</option>
					<option value="-title">Title (Descending)</option>
				</FormControl>
			</div>
			<div>
				<br />
				<center>
					<h4>SAP Repository Filters</h4>
				</center>
				<div>
					<h5>Search</h5>
					<FormGroup>
						<InputGroup>
							<FormControl
								type="search"
								value={searchTerm}
								placeholder="Search name or text"
								onChange={e => handleChangeSAPFilter('searchTerm', e.target.value)}
								onKeyPress={handleEnterPress}
							/>
							<InputGroup.Button>
								<Button
									bsStyle={searchTerm ? "info" : "default"}
									onClick={() => getResourcesWithFilters(1)}
								>
									<Glyphicon glyph="search" />
								</Button>
							</InputGroup.Button>
						</InputGroup>
					</FormGroup>
				</div>
				<Fragment>
					{metaDataFilters.map(type => {
						if (!props[type.dataName] || !props[type.filterName]) {
							return null
						}
						return (
							<div key={`${type.dataName}FilterTypeahead`}>
								<h5>{type.displayName}</h5>
								<Typeahead
									id={`${type.dataName}FilterTypeahead`}
									clearButton
									labelKey={getLabelKeyFunc(type.dataName)}
									multiple
									selected={props[type.filterName]}
									options={props[type.dataName]}
									placeholder={type.displayName}
									onChange={(value) => handleChangeSAPFilter(type.filterName, value)}
								/>
							</div>
						)
					})}
				</Fragment>
			</div>
		</Well>
	)

	return (
		<Fragment>
			<NewSAPResourceModal
				show={showNewSAPResourceModal}
				toggleShow={toggleShowNewSAPResourceModal}
				handleSaveSuccess={(response) => props.history.push(`/sap-repository/${response.data.id}`)}
				history={props.history}
			/>

			<div id="PostSidebar">
				<Col xsHidden smHidden id="large-device">
					{filters}
				</Col>
				<Col mdHidden lgHidden>
					<div id="filter-display-button">
						<Button onClick={() => setOpen(!open)}>
							Show Filters
						</Button>
					</div>
					<Collapse in={open}>
						{filters}
					</Collapse>
				</Col>
			</div>
		</Fragment>
	)
}

const mapStateToProps = (state) => {
	return {
		// DATA
		clients: state.manageLogin.clients,
		contents: state.manageSAPResources.contents,
		dataSources: state.manageSAPResources.dataSources,
		designs: state.manageSAPResources.designs,
		methods: state.manageSAPResources.methods,
		therapeuticAreas: state.manageSAPResources.therapeuticAreas,
		genesisUsers: state.manageLogin.genesisUsers,

		// FILTERS
		sortBy: state.manageSAPResources.sortBy,
		searchTerm: state.manageSAPResources.searchTerm,
		contentFilters: state.manageSAPResources.contentFilters,
		dataSourceFilters: state.manageSAPResources.dataSourceFilters,
		designFilters: state.manageSAPResources.designFilters,
		methodFilters: state.manageSAPResources.methodFilters,
		therapeuticAreaFilters: state.manageSAPResources.therapeuticAreaFilters,
		externalClientFilters: state.manageSAPResources.externalClientFilters,
		authorFilters: state.manageSAPResources.authorFilters
	}
}

const mapDispatchToProps = {
	handleChangeSAPFilter,
}

export default connect(mapStateToProps, mapDispatchToProps)(SAPResourcesSidebar)



// WEBPACK FOOTER //
// ./src/routes/sap-resources/components/SAPResourcesSidebar.js